import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import {CompanyService} from '../../company/company.service';
import {AutorunComponent} from '@myshared/autorun.component';
import {BankAccount, Company} from '../../company/company.model';
import {PaymentMethodCode} from '../buy.model';
import {firstValueFrom} from "rxjs";
import {FormEmitter} from "../../forms/form.component";

@Component({
    selector: 'app-payment-method',
    templateUrl: './payment-method.component.html',
    styleUrls: [],
    standalone: false
})
export class PaymentMethodComponent extends AutorunComponent implements OnInit {
  @Input() public backLabel = 'app_back';
  @Input() public historyBack = true;
  @Input() public company?: Company;
  @Input() public onlyEmit = false;
  @Input() paymentMethod: PaymentMethodCode = 'sepa';

  @Output() public backEvent = new EventEmitter();
  @Output() public readonly next: EventEmitter<{bank?: BankAccount, method?: PaymentMethodCode}>
    = new EventEmitter<{bank?: BankAccount, method?: PaymentMethodCode}>();

  bankAccount: BankAccount;
  initialized = false;

  constructor(private companyService: CompanyService) {
    super();
  }

  async ngOnInit() {
    if (!this.company) {
      this.company = await firstValueFrom(this.companyService.getMyCompany());
    }

    // If the company can do wire transfer because no SEPA exists
    if (this.paymentMethod === 'wire_transfer') {
      this.onNextWireTransfer();
      return;
    }

    if (this.company.hasBankAccount) {
      this.next.emit({});
      return;
    }

    // Create SEPA Form
    if (this.company.bankAccounts.length > 0) {
      this.bankAccount = this.company.bankAccounts[0];
    } else {
      this.bankAccount = BankAccount.fromJson({});
    }

    this.initialized = true;
  }

  onNextWireTransfer() {
    this.next.emit({ method: 'wire_transfer' });
  }

  onNextSepa(form: FormEmitter<BankAccount>) {
    const bankAccount = form.data;
    bankAccount.id = this.bankAccount.id;

    if (this.onlyEmit) {
      this.next.emit({bank: bankAccount, method: 'sepa' });
      return;
    }

    this.companyService.updateBankAccount(bankAccount).subscribe(ok => {
      this.next.emit({bank: bankAccount, method: 'sepa' });
    });
  }

  public onBack() {
    this.backEvent.emit();
  }
}
